<div #modal class="show" id="deleteConfirm" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="table-view">
    <div class="table-cell-view">
      <div class="modal-dialog modal-dialog-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <span>
              <img class="footerimage" [src]="this.searchService.footerLogo">
            </span>
            @if (!disableCancel && !login) {
              <button type="button" class="close" data-dismiss="modal"
                (click)="onCancel()">
                <i class="material-icons">close</i>
              </button>
            }
          </div>
          @if (!this.dashboard && !flightChart) {
            <div class="modal-body">
              <div class="modal-content-heading">
                <h3></h3>
                <h3 [style.color]="color">{{title}} {{index}}</h3>
              </div>
              <div class="modal-content-text modal-content-width">
                <p [style.color]="color" style="max-width: 333px;">{{message}}</p>
              </div>
              @if (!this.profile) {
                <div class="modal-content-button delete-modal-button">
                  <button class="text-button link-primary button1" type="button" [style.color]="buttonColor"
                    (click)="onConfirm()">
                  {{yesButtonSubText}}</button>@if (this.deleteCard && this.userAccountInfoService.deletingCard) {
                  <span
                    class="loaderClass">
                    <loader-dots class="loaderAlign"></loader-dots>
                  </span>
                }
                @if (!disableCancel && !login) {
                  <button class="text-button link-primary button2"
                    [style.color]="buttonColor" (click)="onCancel()" data-dismiss="modal">{{noButtonSubText
                  ? noButtonSubText :('paymentDetails.cancel' | translate)}}</button>
                }
              </div>
            }
            @if (this.profile) {
              <button class="btn btn-secondary" (click)="onConfirm()"><span
              class="add">{{'emailBookingFlow.YES' | translate }}</span></button>
            }
            @if (this.profile) {
              <button class="btn btn-normal" (click)="onCancel()"><span
              class="add1">{{'emailBookingFlow.NO' | translate }}</span></button>
            }
          </div>
        }
        @if (this.dashboard) {
          <div class="modal-body">
            <div class="modal-content-heading">
              <h3></h3>
              <h3>{{title | translate}}</h3>
            </div>
            <div class="modal-content-text modal-content-width">
              <p [style.color]="color" style="max-width: 333px;">{{message}}</p>
            </div>
          </div>
        }
        @if (flightChart) {
          <div class="modal-body">
            <div class="modal-content-heading">
              <h3></h3>
              <h3>{{title | translate}}</h3>
            </div>
            <div class="modal-content-text modal-content-width">
              <div  style="color:#6C6865;text-align: left;line-height: 26px;"[innerHTML]="message"></div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
</div>